import { render, staticRenderFns } from "./SalesCategory.vue?vue&type=template&id=57386ace&scoped=true"
import script from "./SalesCategory.vue?vue&type=script&lang=js"
export * from "./SalesCategory.vue?vue&type=script&lang=js"
import style0 from "./SalesCategory.vue?vue&type=style&index=0&id=57386ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57386ace",
  null
  
)

export default component.exports